

const baseUrl = process.env.REACT_APP_API_URL




export const fetchSinToken = ( endpoint, data, method = 'GET' ) => {

    const url = `${ baseUrl }/${ endpoint } `; 
    
  
    if( method === 'GET' ){
        return fetch( url );
    } else {
        return fetch( url, {
            method,
            headers: {
                'content-type':'application/json'
            },
            body: JSON.stringify( data )
        });
    }
}

export const fetchConToken = ( endpoint, data, method = 'GET' ) => {

    const url = `${ baseUrl }/${ endpoint } `; 
    const token = localStorage.getItem('token') || '';

    if( method === 'GET' ){
        return fetch( url, {
            method,
            headers: {
                'x-token': token
            }
        });
    } else {
        return fetch( url, {
            method,
            headers: {
                'content-type':'application/json',
                'x-token': token
            },
            body: JSON.stringify( data )
        });
    }
}

export const getArray = async(account) => {

    let inve=[];
    let steamId=[];
    let array = [];
    let acc;
//   console.log(account)




if(account.includes('id/')){
    acc = account.split('/')
    
    if(account.includes('.com') && !account.includes('steamcommunity')){
        acc = '6ds+f5sd-////////././,/,/./,/'
    }else{

        acc = acc[acc.length -1] ? acc[acc.length -1] : acc[acc.length -2]
    }
      
        
      
    }else{
        acc = account
    }
    

    await fetch(`https://steamcommunity.com/id/${ acc }/inventory/json/730/2`)
                    .then( result => result.json() )
                    .then(res => inve.push(res))
                    .catch((err) => console.log(err));

    await fetch(`https://api.steampowered.com/ISteamUser/ResolveVanityURL/v0001/?key=FB7F7D3B534015018E8E4A58D180AED3&vanityurl=${ acc }`)
                    .then(result => result.json())
                    .then(res => steamId.push(res))
                    .catch((err) => console.log(err));

                    let steamId64 = steamId[0].response.steamid


                    if(inve.length<1){
                        array = '2'
                    }
                    else if ( !inve[0].Error && inve != null && inve.length>=1){

                        const descripcion = inve[0].rgDescriptions
                        const Descripcion = (Object.values(descripcion))
                     
                        const inv = inve[0].rgInventory
                        const Inventory = (Object.values(inv))
                   
                        // console.log(descripcion)
                        Descripcion.forEach( (item) =>{
                            
                            const {name_color,market_name, icon_url:url, descriptions, market_actions, tags, tradable, cache_expiration, classid, instanceid,type,market_hash_name,fraudwarnings} = item

                            const assetid = Inventory.filter(e => e.classid === item.classid && e.instanceid === item.instanceid)
                            
                        // console.log(item.descriptions[0].value.includes('Estado:')) 
                             let categoria = tags.filter(tag => (tag.internal_name.includes('Rarity_')))
                        
                             let numberMarket = ((market_actions)&&(market_actions[0].link).split("%")[5])
                            //  let names    
                            //  let iconURLs              
                            //        if( (descriptions[6]) && (descriptions[6].value).includes('Pegatina') ){
                            //           names = (descriptions[6].value).split('><br>')[1].split(': ')[1].split('</center>')[0].split(', ');
                            //          // names = handleStickerNamesWithCommas(names);
                            //          iconURLs = (descriptions[6].value).split('src="');
                             
                            //          iconURLs.shift();
                            //          iconURLs.forEach((iconURL, index) => {
                            //            iconURLs[index] = iconURL.split('><')[0];
                            //          });
                             
                            //        }   

                             let sticker = ((descriptions[6]) && (descriptions[6].value).includes('Pegatina'))
                                             ? {
                                                 icon:((descriptions[6].value).split("<br>")[1]).split('<center>')[1],
                                                 name: (descriptions[6].value).split("<br>")[2].split('<')[0],
                                                //  iconURLs
                                             }
                                                 : null
                                  

                            //   if((descriptions[6]) && (descriptions[6].value).includes('Pegatina')){console.log((descriptions[6].value).split("<br>")[2].split('<')[0])  }                 
                            let etiqueta
                             if(fraudwarnings){
                                etiqueta = fraudwarnings[0]
                             }               
                           
                            if(market_name.includes('Souvenir')){
                                categoria = 'Souvenir'

                                sticker = ((descriptions[10]) && (descriptions[10].value).includes('Pegatina'))
                                                ? {
                                                    icon:((descriptions[10].value).split("<br>")[1]).split('<center>')[1],
                                                    name: (descriptions[10].value).split("<br>")[2].split('<')[0]
                                                }
                                                    : null
                            }else{
                                categoria =  categoria[0].internal_name.split('_')[1]
                            }

                            //  let tradeLock = (owner_descriptions !== "") && (owner_descriptions[1].value).slice(28,34)
                            let tradeLock = (cache_expiration)?cache_expiration:null
                            
                             let markAction =  (market_actions)? market_actions[0].link : null  
                             let inspect = `steam://rungame/730/76561202255233023/+csgo_econ_action_preview%20S${steamId64}A${assetid[0].id}${numberMarket}`
                      
                            let tieneFloat = item.descriptions[0].value.includes('Estado:')
                            let viewInInventary = `https://steamcommunity.com/id/${ acc }/inventory/#730_2_${assetid[0].id}`
        
                               array.push({ 
                                     idSteamItem: `${classid}_${instanceid}`,
                                     acc,
                                    //  float :float[0],
                                     nombre: market_name,
                                     name_color,
                                     imagen: `https://community.cloudflare.steamstatic.com/economy/image/${ url }`, 
                                     cantidad: assetid.length,
                                     categoria,
                                     sticker,
                                     tieneFloat,
                                     type,
                                     market_hash_name,
                                     listings:`https://steamcommunity.com/market/listings/730/${market_hash_name}`,
                                     viewInInventary,
                                //    destacado: false,
                                    etiqueta,
                                     inspect,
                                     tradable,                           
                                    tradeLock,
                                     sell:false
                                     
                                     })

                                   
      
                             })



                             
  
                    }
                    else if (inve[0].Error) {
                        
                        array = '1'
                    }



// console.log([1,2,3])
   return  array;

}



export const getFloat = async(prod) =>{

let float = null
        if(prod.inspect){

            if(prod.inspect.includes("undefinded")){
                return float
            }
            await fetch(`https://api.csgofloat.com/?url=${prod.inspect}`, {
                'mode': 'cors'
               
            })
            .then( result =>result.json())
            // .then(res => console.log(res.iteminfo.floatvalue))
            .then(res => {
              
                    if(!res.iteminfo.floatvalue){
                        float = null
                    }
                    if (!res.error && res.iteminfo.floatvalue !== 0){
                                                
                        float = (res.iteminfo.floatvalue).toFixed(3)
                    }
                    if(res.iteminfo.floatvalue === 0){
                        float = null
                    }
                })
         
        }
        return float
}




export const getTradeLock = (tradeLock) => {
    if (tradeLock === 'Tradable' || tradeLock === '') return '';
    const now = new Date().getTime();
    const distance = new Date(tradeLock) - now;
    if (distance <= 0) return '';
  
    const days = Math.floor((distance / (1000 * 60 * 60 * 24))+1);
    // const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    // const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    // const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    // if (days === 0) {
    //   if (hours === 0) {
    //     if (minutes === 0) {
    //       if (seconds === 0) return '';
    //       return `${seconds} segundos`;
    //     }
    //     return `${minutes} minutos`;
    //   }
    //   return `${hours} horas`;
    // }
    return `${days} dias`;
  };

export const getPriceSteamCheck = async(market_hash_name) =>{
    
let priceSteam 

    await fetch(`https://steamcommunity.com/market/priceoverview/?appid=730&currency=34&market_hash_name=${market_hash_name}`)
    .then(resp => resp.json())
    .then(res => priceSteam = res )

    return priceSteam
} 
                           